import {EmptyLayout} from '../../containers/Common';
import LoginForm from './LoginForm';

const Login = () => {
  return <EmptyLayout>
    <LoginForm/>
  </EmptyLayout>;
}

export default Login;